<template>
  <div class="hero">
    <div class="container">
      <h3>Gefeliciteerd</h3>
      <h1>De demo is met succes aangevraagd</h1>
      <p>
        Bedankt voor het aanvragen van een demo bij Roosterplatform. We nemen
        z.s.m. contact met u op
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "DemoAangevraagd",

  mounted() {},

  metaInfo() {
    return {
      title: "Roosterplatform - Demo-aangevraagd",
    };
  },
};
</script>

<style scoped lang="scss">
@import "../assets/css/colors.scss";
@import "../assets/css/variables.scss";

.hero {
  padding: 100px 0 200px;
  position: relative;
  z-index: 1;
  p {
    font-size: $big;
  }
  h3 {
    opacity: 0.3;
    font-weight: 700;
  }
}

.blog-item {
  display: flex;
  gap: 20px;
  margin-bottom: 70px;
  .image {
    width: 300px;
    min-width: 300px;
    max-width: 300px;

    img {
      border-radius: 8px;
      margin-block: 16px;
      width: 100%;
      margin: 0;
    }
  }
  h3 {
    opacity: 1;
  }

  .blog-short-desc {
    p {
      display: -webkit-box;
      max-width: 100%;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }
}

@media (max-width: 767px) {
  .hero {
    padding-top: $header-height-small;
  }
  .blog-item {
    display: block;
    .image {
      width: 100%;
      min-width: 100%;
      max-width: 100%;

      img {
        width: 100%;
        margin-block: 10px;
      }
    }
  }
}
</style>
